import { Digest } from "./[topicId]/edit.page";
import { useMemo, useState } from "react";
import { useDeepLinks } from "src/hooks/useDeepLinks";
import { AnnotatedDeepLink, DeepLinkType } from "pages/api/deep-links/types";
import { Flex } from "src/components/Flex";
import { Button, List, Select } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

export function DigestLinks(props: { digest: Digest }) {
  const [links, setLinks] = useState(props.digest.link?.json.links || []);
  const link = props.digest.link;
  const { save } = props.digest;

  const digests = useDeepLinks(DeepLinkType.DIGEST_2);
  const queries = useDeepLinks(DeepLinkType.EXPLORE);
  const boards = useDeepLinks(DeepLinkType.BOARD);

  const options = useMemo(() => {
    const isLoading =
      digests.links.isLoading ||
      queries.links.isLoading ||
      boards.links.isLoading;
    if (isLoading) return {};
    return {
      [DeepLinkType.DIGEST_2]: digests.links.data || [],
      [DeepLinkType.EXPLORE]: queries.links.data || [],
      [DeepLinkType.BOARD]: boards.links.data || [],
    };
  }, [digests, queries, boards]);

  return (
    <>
      <List
        dataSource={links}
        renderItem={(l) => (
          <List.Item>
            <Flex gap={12} start>
              {
                (options as Record<DeepLinkType, AnnotatedDeepLink[]>)[
                  l.type
                ]?.find((o) => o.id == l.id)?.name
              }
              <DeleteOutlined
                onClick={() =>
                  setLinks(links.filter((link) => link.id != l.id))
                }
              />
            </Flex>
          </List.Item>
        )}
      />

      <LinkSelector
        options={options}
        onAdd={(id) => {
          const item = Object.values(options)
            .flat()
            .find((item) => item.id == id) as AnnotatedDeepLink;
          setLinks((previousLinks) => {
            const newLinks = [
              ...previousLinks.filter((l) => l.id != item.id),
              { id: item.id, type: item.type as DeepLinkType },
            ];
            save({
              id: link!.id,
              name: link!.name,
              description: link!.description,
              ...link!.json,
              links: newLinks,
            });
            return newLinks;
          });
        }}
      />
    </>
  );
}

// a way to select a deepLink among all the options

const LinkSelector = (props: {
  options: Partial<Record<DeepLinkType, AnnotatedDeepLink[]>>;
  onAdd: (id: string) => void;
}) => {
  const [type, setType] = useState<DeepLinkType>();
  const [selected, setSelected] = useState<string>();
  const types = Object.keys(props.options) as DeepLinkType[];

  const currentOptions = useMemo(() => {
    if (!type) return undefined;
    return props.options[type] || [];
  }, [type, props.options]);

  return (
    <Flex gap={12} start>
      <Select
        options={types.map((t) => ({ label: t, value: t }))}
        value={type}
        onChange={setType}
        style={{ width: 150 }}
        placeholder="link type"
      />
      {currentOptions ? (
        <>
          <Select
            options={currentOptions.map((l) => ({
              label: l.name,
              value: l.id,
            }))}
            onChange={setSelected}
            style={{ width: 250 }}
            showSearch
          />
          <Button
            disabled={!selected}
            type="primary"
            onClick={() => selected && props.onAdd(selected)}
          >
            Add
          </Button>
        </>
      ) : (
        <></>
      )}
    </Flex>
  );
};
